import { Divider, Typography } from '@mui/material'
import React from 'react'
import { SourcesTable } from '../../components/entities/SourcesTable'
import InfoBlock from '../components/InfoBlock'
import { CompensationGuarantors } from './CompensationGuarantors'
import { RelatedIssues } from './RelatedIssues'
import { IssueEntity } from '../../types/IssueEntity'
import { FactsTable, FactsTableRow } from '../components/FactsTable'

function IssueComments({ issue }) {
    const linkedIssues = issue.linkedIssues.map((g) => g.issues).flat() as IssueEntity[]
    const guarantorFeeSource = linkedIssues
        .find((i) => i.type === 'Guarantor fee issue')
        ?.sources.find((s) => s.sourceType === 'Publication')
    const sources = React.useMemo(
        () =>
            [
                ...issue.sources,
                !guarantorFeeSource ? undefined : { ...guarantorFeeSource, sourceType: 'Garantiersättning' },
            ].filter((s) => !!s),
        [issue, guarantorFeeSource],
    )

    const showIsins = issue.type === 'Rights issue' && (issue.isinRights || issue.isinUnits)

    if (!issue?.externalComment && !sources.length && !showIsins) return null

    return (
        <InfoBlock title='Övrigt'>
            {showIsins ? (
                <FactsTable>
                    <FactsTableRow hasDivider={false} hasBottomPadding={!issue.isinUnits} label='ISIN Teckningsrätt'>
                        {issue.isinRights}
                    </FactsTableRow>
                    {issue.isinUnits ? (
                        <FactsTableRow hasDivider={false} label='ISIN Unit'>
                            {issue.isinUnits}
                        </FactsTableRow>
                    ) : null}
                </FactsTable>
            ) : null}
            {issue.earnout && issue.type === 'Non-cash issue' ? (
                <>
                    <Typography
                        variant='body1'
                        sx={{
                            my: 4,
                        }}
                    >
                        Emissionen avser en tilläggsköpeskilling
                    </Typography>
                    <Divider />
                </>
            ) : null}
            {issue.linkedIssues.length > 0 ? <RelatedIssues linkedIssues={issue.linkedIssues} /> : null}
            {issue.linkedIssues.length > 0 ? <CompensationGuarantors issue={issue} /> : null}
            {sources.length > 0 ? <SourcesTable companyId={issue.companyId} sources={sources} /> : null}
        </InfoBlock>
    )
}

export default IssueComments
